import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface BannerProps {
  title: string;
  description: string;
  url: string;
  backgroundColor?: string;
  textColor?: string;
}

interface DoubleBannerNavProps {
  leftBanner: BannerProps;
  rightBanner: BannerProps;
}

export const DoubleBannerNav: React.FC<DoubleBannerNavProps> = ({
  leftBanner,
  rightBanner,
}) => {
  const { i18n } = useTranslation();

  return (
    <div className="double-banner-nav">
      {[leftBanner, rightBanner].map((banner, index) => (
        <Link
          key={index}
          to={`/${i18n.language}${banner.url}`}
          className="banner"
          style={{
            backgroundColor: banner.backgroundColor || "#fdfdfd",
            color: banner.textColor || "#000",
          }}
        >
          <h4>{banner.title}</h4>
          <p>{banner.description}</p>
        </Link>
      ))}
    </div>
  );
};
